import {useItemsDashboard} from '@kit';

import React from 'react';

import {Layout} from '../../components/layout';
import {NotFoundSeo, SectionSeo} from '../../lib/seo';
import {useClassesQuery} from '../../generated/types';
import {cls, getApolloError} from '../../components/utils';
import {ClassLayout} from './layout';
import {useRoute} from '../../lib/routes';

import css from '@kit/sidebar/dashboard.module.css';
import pageCss from '../../components/common.module.css';

type Props = {};

export const ClassesPage: React.FC<Props> = () => {
	const {data, loading, error} = useClassesQuery({
		ssr: true,
	});

	const router = useRoute();
	const query = router?.query || {};

	const {selectedId, selected, showView, handleBack, Sidebar, notFound} = useItemsDashboard({
		items: data?.classes || [],
		id: query.id as string,
		loading,
		route: 'class',
		baseRoute: 'classes',
		sidebarHeader: (heroClass) => heroClass.title,
		sidebarSecondary: (heroClass) => (
			<div>
				<div>{heroClass.shortDescription}</div>
				<div>D{heroClass.hitDie}</div>
			</div>
		),
	});

	const title = showView && selected ? selected.title : 'Классы';

	return (
		<Layout handleBack={selected && handleBack}>
			{!selectedId && <SectionSeo section="classes" />}
			{notFound && <NotFoundSeo />}
			<div className={css.dashboard}>
				{error ? (
					<div className={pageCss.fullSizeBlock}>{getApolloError(error).message}</div>
				) : (
					<div className={cls(css.dashboardWrapper, showView && css.showView)}>
						<div className={css.sidebar}>{Sidebar}</div>
						<div className={css.view}>
							{selectedId && showView ? (
								<ClassLayout classId={selectedId} title={title} />
							) : (
								<div className={pageCss.fullSizeBlock}>Выберите класс</div>
							)}
						</div>
					</div>
				)}
			</div>
		</Layout>
	);
};
